import { makeStyles } from '@material-ui/core';

export default makeStyles(({ palette, spacing }: any) => ({
  qrReader: {
    width: '100%',
    border: `2.5px solid ${palette.primary.main}`,
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: palette.common.grey,
  },
  errorBanner: {
    position: 'absolute',
    zIndex: 2,
    top: 0,
    opacity: 0,
    visibility: 'hidden',
    borderRadius: spacing(1.25),
    width: spacing(87.5),
    height: spacing(16.5),
  },
  errorMessage: {
    fontSize: '16px',
    lineHeight: '21px',
    fontWeight: 700,
  },
  fadeIn: {
    visibility: 'visible',
    animation: '$fadeInOut 12s ease-in-out forwards',
  },
  '@keyframes fadeInOut': {
    '0%': {
      opacity: 0,
      transform: 'translateY(-40px)',
    },
    '6%': {
      transform: 'translateY(20px)',
    },
    '8%, 95%': {
      opacity: 1,
      transform: 'translateY(0)',
      top: '60px',
    },
    '100%': {
      opacity: 0,
    },
  },
}));
